'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../button/button.js';

/**
 * DropdownButton component, used to display a button in the DropdownItem.
 *
 * @example
 * <Dropdown>
 *  <DropdownList>
 *    <DropdownItem>
 *      <DropdownButton>Button</DropdownButton>
 *    </DropdownItem>
 *  </DropdownList>
 * </Dropdown>
 */
const DropdownButton = forwardRef(function DropdownButton({ ...rest }, ref) {
    return jsx(Button, { ref: ref, variant: 'tertiary', ...rest });
});

export { DropdownButton };
